export default __webpack_public_path__ + "static/media/misdirection.9cf362b2.png";